import { useMemo } from "react";
import { useRecoilValue } from "recoil";

import { useDynamicGridTranslate } from "@ryde/redux";
import {
  FIELD_TYPE_IDS,
  gridControlsSF,
  IGenericUploadEntityCreateFieldItem,
  RydeUiUnit,
} from "@ryde/shared";

export const useGenericUploadEntityCreateFields = (
  entity: RydeUiUnit,
): IGenericUploadEntityCreateFieldItem[] => {
  const { getGridLabelComputed } = useDynamicGridTranslate();
  const gridControls = useRecoilValue(gridControlsSF(entity));

  return useMemo(() => {
    const options: IGenericUploadEntityCreateFieldItem[] = [];

    for (const gridControl of gridControls) {
      if (!gridControl.id) {
        continue;
      }

      if (gridControl.formFieldTypeId !== FIELD_TYPE_IDS.FORM.dropdown_bound) {
        continue;
      }
      const itemEntity = gridControl.formAttributes?.dropItemsSource;

      if (!itemEntity) {
        continue;
      }

      options.push({
        entity: itemEntity,
        customFieldId: gridControl.id,
        label: getGridLabelComputed(entity, gridControl),
        isAllow: !!gridControl.formAttributes?.allowCreateIfNotFound,
      });
    }

    return options;
  }, [entity, gridControls, getGridLabelComputed]);
};
